<template>
    <v-container fluid class="pa-0 fill-height" style="background-color: #20242f;">
        <v-row
            no-gutters
            class="fill-height"
            align="center"
            justify="center"
        >
            
            <v-col cols="12">

                <!-- Welcome to Damae's dermoscopy cloud -->
                <v-row align="center" justify="center">
                    <v-col cols="12" class="text-center">
                        <h1 class="text-white">Welcome to Damae's dermoscopy cloud</h1>
                        <p class="mt-3 text-white">
                            Please enter your credentials to access the platform.
                        </p>
                    </v-col>

                    <v-col cols="2" class="mt-5 text-center">
                        <v-text-field
                            v-model="password"
                            label="Password"
                            type="password"
                            outlined
                            dense
                            class="text-white"
                            @keyup.enter="login"
                        />

                        <v-btn
                            color="primary"
                            @click="login"
                        >
                            Login
                        </v-btn>
                    </v-col>
                </v-row>

            </v-col>

            <v-snackbar
                v-model="showSnackbar"
                :color="snackbarColor"
                timeout="3000"
            >
                {{ snackbarMessage }}
            </v-snackbar>

        </v-row>
    </v-container>
</template>

<script lang="ts" src="./Authentication.ts" />